"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntermediaryExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="intermediary-excellence" className="relative w-full overflow-hidden bg-background py-24 md:py-32 lg:py-40 flex items-center justify-center">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none z-0 overflow-hidden" aria-hidden="true">
        <span className="text-[12vw] font-serif font-bold text-foreground/[0.03] whitespace-nowrap tracking-tighter">
          RSVP Enterprises
        </span>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6 font-sans">
          Business Tantra: The Commercialization Arm.
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">
          Operating from Delhi, India, we serve as the trusted intermediary for premium brand acquisition. Backed by the institutional strength of RSVP Enterprises, we curate, structure, and place legally verified trademarks with businesses ready to launch quickly and compliantly.
        </p>

        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 h-12 text-base font-medium shadow-lg shadow-primary/20 transition-all hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5">
          <Link to="/AboutBusinessTantraPage">
            Learn Our Story
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}